







































import BaseComponent from "@/components/base/BaseComponent";
import {Component, Prop} from "vue-property-decorator";
import { v4 as uuidv4 } from 'uuid';

@Component
export default class MoneyWithdrawalDetails extends BaseComponent {
  @Prop({ type: String, required: true }) private title!: string;

  private employeeBenefitWithdrawal: number = 0; // Default to 0
  private benefitPartWithdrawValue: string = "0"; // Default to '0'
  private isPartWithdrawalDisabled: boolean = false;
  private uniqueId = uuidv4();



  // Handles the radio button change
  private onRadioChange(value: number): void {
    this.employeeBenefitWithdrawal = value;

    if (value === 0) {
      this.benefitPartWithdrawValue = "0";
      this.isPartWithdrawalDisabled = true;
    } else {
      this.isPartWithdrawalDisabled = false;
    }

    this.$emit("handleChange", value, this.benefitPartWithdrawValue);
  }

  private moneyFormat(value: string): string {
    const num = parseFloat(value.replace(/,/g, ""));
    return isNaN(num) ? "0" : num.toLocaleString();
  }

  onInputChange(newValue: string): void {
    this.benefitPartWithdrawValue = newValue;
    this.$emit("handleChange", this.employeeBenefitWithdrawal, this.parseNumberString(this.benefitPartWithdrawValue)); // Emit the new value
  }


  parseNumberString(value: string): number {
    return parseInt(value.replace(/,/g, ''), 10);
  }
}
